<template>
    <div>
        <Confirm
            v-for="dialog in dialogQueue"
            :key="dialog.id"
            v-bind="dialog.props"
            model-value
            @confirm="dialog.resolve(true)"
            @cancel="dialog.resolve(false)"
            @close="dialog.resolve(0)"
        />
    </div>
</template>

<script setup>
const { $dialogQueue } = useNuxtApp()
const dialogQueue = $dialogQueue
</script>
